import { browserUrl } from "../../../shared/browserUrl";

export type PlatformAppId =
  "auth" | "learners" | "parents" | "instructors" | "proctors" | "organizations" | "institutions";

export const APP_ID: PlatformAppId = "institutions";

const readEnvironment = (key: string, fallback: string) => {
  const value = import.meta.env[key];
  return browserUrl(typeof value === "string" && value.trim() ? value : fallback);
};

export const platformEnvironment = Object.freeze({
  apiBaseUrl: readEnvironment("VITE_ACADEMY_API_BASE_URL", "https://api.academy.chatoner.com"),
  classOrigin: readEnvironment("VITE_CLASS_ORIGIN", "https://class.chatoner.com"),
  labsOrigin: readEnvironment("VITE_LABS_ORIGIN", "https://labs.chatoner.com"),
  appOrigins: Object.freeze({
    auth: readEnvironment("VITE_ACADEMY_ACCESS_URL", "https://academy.chatoner.com/platform-access/auth"),
    learners: readEnvironment("VITE_LEARNERS_ORIGIN", "https://learners.academy.chatoner.com"),
    parents: readEnvironment("VITE_PARENTS_ORIGIN", "https://parent.academy.chatoner.com"),
    instructors: readEnvironment("VITE_INSTRUCTORS_ORIGIN", "https://instructors.academy.chatoner.com"),
    proctors: readEnvironment("VITE_PROCTORS_ORIGIN", "https://proctors.academy.chatoner.com"),
    organizations: readEnvironment("VITE_ORGANIZATIONS_ORIGIN", "https://organizations.academy.chatoner.com"),
    institutions: readEnvironment("VITE_INSTITUTIONS_ORIGIN", "https://institutions.academy.chatoner.com"),
  }),
});
const localPorts: Record<PlatformAppId, number> = {
  auth: 5273,
  learners: 5274,
  parents: 5275,
  instructors: 5276,
  proctors: 5277,
  organizations: 5278,
  institutions: 5279,
};
export function appBaseUrl(app: PlatformAppId) {
  const environmentKeys: Record<PlatformAppId, string> = {
    auth: "VITE_ACADEMY_ACCESS_URL",
    learners: "VITE_LEARNERS_ORIGIN",
    parents: "VITE_PARENTS_ORIGIN",
    instructors: "VITE_INSTRUCTORS_ORIGIN",
    proctors: "VITE_PROCTORS_ORIGIN",
    organizations: "VITE_ORGANIZATIONS_ORIGIN",
    institutions: "VITE_INSTITUTIONS_ORIGIN",
  };
  if (import.meta.env[environmentKeys[app]]) return platformEnvironment.appOrigins[app];
  if (
    import.meta.env.DEV &&
    typeof window !== "undefined" &&
    /^(localhost|127\.0\.0\.1)$/.test(window.location.hostname)
  )
    return `${window.location.protocol}//${window.location.hostname}:${localPorts[app]}${
      app === "auth" ? "/auth" : ""
    }`;
  return platformEnvironment.appOrigins[app];
}

export function appOrigin(app: PlatformAppId) {
  return new URL(appBaseUrl(app)).origin;
}

export function appUrl(app: PlatformAppId, path = "") {
  const normalizedPath = path.replace(/^\/+/, "");
  const baseUrl = appBaseUrl(app);
  return normalizedPath ? new URL(normalizedPath, `${baseUrl}/`).toString() : baseUrl;
}
